exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --reach-skip-nav: 1;\n}\n\n[data-reach-skip-nav-link] {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  position: absolute;\n}\n\n[data-reach-skip-nav-link]:focus {\n  padding: 1rem;\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  background: white;\n  z-index: 1;\n  width: auto;\n  height: auto;\n  clip: auto;\n}\n", ""]);

// exports
